<template>
  <div 
    class="documents-grid-view" 
    role="list"
    :aria-label="`${documents.length} document${documents.length !== 1 ? 's' : ''} in grid view`"
  >
    <document-card
      v-for="document in documents"
      :key="document.id"
      :document="document"
      :can-edit="canEdit"
      :can-delete="canDelete"
      role="listitem"
      @preview="handlePreview"
      @download="handleDownload"
      @edit="handleEdit"
      @delete="handleDelete"
    />
  </div>
</template>

<script>
import DocumentCard from './DocumentCard.vue';

export default {
  name: 'DocumentsGridView',
  
  components: {
    DocumentCard
  },
  
  props: {
    documents: {
      type: Array,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  
  methods: {
    handlePreview(document) {
      this.$emit('preview', document);
    },
    
    handleDownload(document) {
      this.$emit('download', document);
    },
    
    handleEdit(document) {
      this.$emit('edit', document);
    },
    
    handleDelete(document) {
      this.$emit('delete', document);
    }
  }
};
</script>
